__turbopack_context__.v({
  "root": "PrimaryButton-module__gpT9ja__root" + " " + __turbopack_context__.i(931616)["ctaStyle"],
});
